import { InputIcon } from "@platform/ui-library";
import { debounce } from 'lodash';
import ReactDOM from "react-dom";
import {
    ChannelSettingSelector,
    LanguageSettingSelector,
    LanguageList,
    ManageChannelsModal
} from "@app/page-components";
import { getGlobalSettings } from "@app/stores";
import { ObjectClass, TimeInMs } from "@app/types";
import { getPromptsUsedInModule } from "@app/utilities";
import LocaleImportCSV from "@app/widgets/dialogs/LocaleImportCSV";
import BaseComponent from "./BaseComponent";
import Button from "./Button";
import LocaleModuleNodeGroup from "./LocaleModuleNodeGroup";
import ReferenceableNodeGroup from "./ReferenceableNodeGroup";
import UnusedPromptsNodeGroup from "./UnusedPromptsNodeGroup";
import { VirtualScroll } from "./virtual-scroll";

export default class Locale extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            isChannelModalOpen: false,
            isLanguageModalOpen: false,
            promptsByModule: [],
            searchText: ''
        };
        this._updatePromptsByModule = this._updatePromptsByModule.bind(this);
    }
    
    UNSAFE_componentWillMount() {
        this._updatePromptsByModule();
    }

    componentWillUnmount() {
        this._debounceUpdatePromptsByModule.cancel();
    }

    setConfig(key) {
        const modIndex = window.apm.getAttachments("module").findIndex(element => element.id === key);
        if (modIndex !== -1) {
            window.apm.getAttachments("module")[modIndex] = voice;
            window.apm.setSerializedChanged();
        }
    }

    getConfig(key) {
        if (key === "lang") {
            return getGlobalSettings().language;
        } else {
            const modIndex = window.apm.getAttachments("module").findIndex(element => element.id === key);
            if (modIndex !== -1) {
                return window.apm.getAttachments("module")[modIndex];
            }
        }
    }

    render() {
        const { language, voice, channel, setSettings } = getGlobalSettings();
        const { serialized } = window.apm;
        const { isOmniChannel } = serialized.omniChannel;
        const {
            isChannelModalOpen,
            isLanguageModalOpen,
            promptsByModule,
            searchText
        } = this.state;
        const referenceablePrompts = serialized.components.objects.filter((o) => {
            return o._class === ObjectClass.prompt && o.props.config.isReferenceable;
        });

        return (
            <div>
                <div className="row">
                    <div className={"col-md-6"} style={{ paddingTop: "6px" }}>
                        <LanguageSettingSelector onChange={this._updatePromptsByModule} />
                        <Button
                            context={this}
                            label={window.l.toolbar.manage_languages}
                            asLink={true}
                            callback={() => {
                                this.setState({ isLanguageModalOpen: true });
                            }}
                        />
                        <LanguageList
                            isOpen={isLanguageModalOpen}
                            onChange={this._updatePromptsByModule}
                            onComplete={() => {
                                this.setState({ isLanguageModalOpen: false });
                            }}
                        />
                    </div>

                    <div className={"col-md-3"} style={{ paddingTop: "6px" }}>
                        {(!isOmniChannel) ? null : (
                            <>
                                <ChannelSettingSelector onChange={this._updatePromptsByModule} />
                                <Button
                                    asLink={true}
                                    callback={() => {
                                        this.setState({ isChannelModalOpen: true });
                                    }}
                                    label="Manage Channels"
                                />
                                <ManageChannelsModal
                                    isOpen={isChannelModalOpen}
                                    onComplete={(newRootSettings) => {
                                        if (newRootSettings) {
                                            window.apm.setBasic("rootSettings", newRootSettings);
                                            const { channels, defaultChannel } = newRootSettings;
                                            if (!(channel in channels)) {
                                                setSettings({ channel: defaultChannel });
                                            }
                                            this.setState({ isChannelModalOpen: false });
                                        }
                                    }}
                                    serialized={serialized}
                                />
                            </>
                        )}
                    </div>

                    <div className={"col-md-3 container-align-right"}>
                        <Button label={"+"} type={"small"} desc={"Import CSV"}
                            callback={() => {
                                window.apm.popup(window.l.settings.csv_data,
                                    '<div class="custom_script_container"></div>',
                                    '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                                    '<button class="w2ui-btn primary add-button">' + window.l.popup.upload_csv + '</button> ',
                                    [
                                        ".custom_script_container",
                                        () => {
                                            ReactDOM.render(
                                                <LocaleImportCSV />,
                                                $(".custom_script_container").get(0),
                                            );
                                            $(".w2ui-popup").find(".add-button").on("click", function () {
                                                document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                            });

                                        }

                                    ]

                                );
                            }}
                            context={this}
                        />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-md-4">
                        <InputIcon
                            name="localeSearch"
                            onChange={(e) => {
                                const value = e.currentTarget.value;
                                this.setState({ searchText: value });
                                this._debounceUpdatePromptsByModule();
                            }}
                            placeholder="Search modules, prompts, or prompt text"
                            value={searchText}
                        />
                    </div>
                </div>
                <br />
                <div className={"row"}>
                    <VirtualScroll
                        estimateItemSize={({ prompts }) => {
                            const moduleHeadingHeight = 38;
                            const promptHeadingHeight = 36;
                            const promptRowHeight = 128;

                            return (
                                moduleHeadingHeight
                                + promptHeadingHeight
                                + (promptRowHeight * prompts.length)
                            );
                        }}
                        footer={(
                            <>
                                <ReferenceableNodeGroup
                                    context={this}
                                    lang={language}
                                    language={language}
                                    referenceablePrompts={referenceablePrompts}
                                    voice={voice}
                                />
                                <UnusedPromptsNodeGroup
                                    context={this}
                                    key={"unusedPrompts"}
                                    lang={language}
                                    language={language}
                                    serialized={serialized}
                                    voice={voice}
                                />
                            </>
                        )}
                        getItemKey={({ mod }) => mod.id}
                        items={promptsByModule}
                        renderItem={({ mod, prompts }) => {
                            return (
                                <LocaleModuleNodeGroup mod={mod} prompts={prompts} />
                            );
                        }}
                        styles={{ scrollContainer: { height: 'calc(100vh - 200px)' } }}
                    />
                </div>
            </div>
        );
    }

    _debounceUpdatePromptsByModule = debounce(() => {
        this._updatePromptsByModule();
    }, 0.1 * TimeInMs.second);

    _updatePromptsByModule() {
        const { serialized } = window.apm;

        const lowerSearch = this.state.searchText.toLowerCase();
        const promptsByModule = serialized.components.modules.map((mod) => {
            const allPrompts = getPromptsUsedInModule(mod);
            const showAll = (
                !lowerSearch.trim()
                || mod.name.toLowerCase().includes(lowerSearch)
            );

            const prompts = (showAll) ? allPrompts : (
                allPrompts.filter(({ prompt, primaryLanguageText, selectedLanguageText }) => (
                    (prompt.name ?? '').toLowerCase().includes(lowerSearch)
                    || primaryLanguageText.toLowerCase().includes(lowerSearch)
                    || selectedLanguageText.toLowerCase().includes(lowerSearch)
                ))
            );
            return { mod, prompts };
        }).filter(({ prompts }) => prompts.length);

        this.setState({ promptsByModule });
    }
}
